import { PortableText } from '@portabletext/react';

import React from 'react';

import ArticleTableOfContent from '_components/article-v3/ArticleTableOfContent';
import InlineQuote from '_components/InlineQuote';
import ListTitle from '_components/ListTitle';
import ProsConsTable from '_components/ProsConsTable';
import { generateTitleId } from '_utils/articles';
import {
  ImageComponent,
  YoutubeComponent,
} from '_utils/blockContentSerializers';

const getTextFromNode = (node) => {
  if (typeof node === 'string') {
    return node;
  }
  if (node.props?.children) {
    return getTextFromNode(node.props.children[0]);
  }
  return '';
};

const travelArticleContent = (content) => {
  const r = [];
  content.forEach((item) => {
    if (['h1', 'h2', 'h3', 'h4', 'ostitle'].includes(item.style)) {
      r.push(item.children[0].text);
    }
    if (item.children) {
      travelArticleContent(item.children);
    }
  });
  return r;
};

export default function ArticlePortableText({ content }) {
  const allTitles = React.useMemo(
    () => travelArticleContent(content),
    [content],
  );

  const components = {
    block: {
      osquote: InlineQuote,
      ostitle: ({ children }) => (
        <div className="mt-8 mb-5">
          <ListTitle
            showAction={false}
            fontSize={26}
            className="scroll-mt-52"
            id={generateTitleId(getTextFromNode(children[0]))}
          >
            {children}
          </ListTitle>
        </div>
      ),
      h1: ({ children }) => {
        const text = getTextFromNode(children[0]);
        return (
          <h1
            className="font-bold text-3xl scroll-mt-52"
            id={generateTitleId(text)}
          >
            {children}
          </h1>
        );
      },
      h2: ({ children }) => {
        const text = getTextFromNode(children[0]);
        return (
          <h2
            className="font-bold text-2xl scroll-mt-52"
            id={generateTitleId(text)}
          >
            {children}
          </h2>
        );
      },
      h3: ({ children }) => {
        const text = getTextFromNode(children[0]);
        return (
          <h3
            className="font-bold text-xl scroll-mt-52"
            id={generateTitleId(text)}
          >
            {children}
          </h3>
        );
      },
      h4: ({ children }) => {
        const text = getTextFromNode(children[0]);
        return (
          <h4
            className="font-bold text-lg scroll-mt-52"
            id={generateTitleId(text)}
          >
            {children}
          </h4>
        );
      },
      normal: ({ children }) => (
        <p className="text-base leading-7 font-normal">{children}</p>
      ),
    },

    list: (props) => <ul>{props.children}</ul>,
    listItem: (props) => <li>{props.children}</li>,
    types: {
      image: ImageComponent,
      youtube: YoutubeComponent,
      prosConsTable: (props) => <ProsConsTable value={props.value} />,
      tableOfContents: () => <ArticleTableOfContent titles={allTitles} />,
    },
  };

  return <PortableText value={content} components={components} />;
}
